// src/lib/utils.js
// Pure utility functions — date helpers, audio, favicon

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};
export const localDateISO = (d) => {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};
export const startOfWeek = (d) => { const x=new Date(d),day=x.getDay(); x.setDate(x.getDate()-day); x.setHours(0,0,0,0); return x; };
export const startOfDisplayWeek = (d,ws=0) => { const x=new Date(d),day=(x.getDay()-ws+7)%7; x.setDate(x.getDate()-day); x.setHours(0,0,0,0); return x; };
export const addDays = (d,n) => { const x=new Date(d); x.setDate(x.getDate()+n); return x; };
export const fmtDayShort = (d) => d.toLocaleDateString('en-US',{weekday:"short"}).replace('.','');
export const fmtMD = (d) => d.toLocaleDateString('en-US',{month:"short",day:"numeric"});
export const ordinal = (n) => { if(n>3&&n<21)return n+'th'; switch(n%10){case 1:return n+'st';case 2:return n+'nd';case 3:return n+'rd';default:return n+'th';} };
export const fmtMDOrdinal = (d) => `${d.toLocaleDateString('en-US',{month:"short"})} ${ordinal(d.getDate())}`;
export const fmtMonthYear = (d) => d.toLocaleDateString('en-US',{month:"long",year:"numeric"});
export const fmtDate = (d, fmt='long') => {
  if(!d) return '';
  const date = d instanceof Date ? d : new Date(d);
  if(fmt==='short') return `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
  return `${date.toLocaleDateString('en-US',{month:'long'})} ${ordinal(date.getDate())}, ${date.getFullYear()}`;
};
export const fmtTime = (d) => {
  if(!d) return '';
  const date = d instanceof Date ? d : new Date(d);
  let hours = date.getHours();
  const mins = String(date.getMinutes()).padStart(2,'0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${hours}:${mins}${ampm}`;
};
export const fmtDateTime = (d, dateFmt='long') => `${fmtDate(d, dateFmt)} at ${fmtTime(d)}`;

export const isDueThatDay = (chore, d) => {
  if(chore.startDate){
    const s=new Date(chore.startDate+'T00:00:00');
    const dy=new Date(localDateISO(d)+'T00:00:00');
    if(dy<s) return false;
  }
  const jsDay=d.getDay(), dow=(jsDay+6)%7;
  switch(chore.frequency){
    case"one-time": return chore.startDate ? localDateISO(d)===chore.startDate : false;
    case"daily":    return true;
    case"weekdays": return dow<=4;
    case"weekends": return dow>=5;
    case"weekly":   return jsDay===(chore.dayOfWeek??0);
    case"monthly":  { const t=chore.dayOfMonth??1, dim=new Date(d.getFullYear(),d.getMonth()+1,0).getDate(); return d.getDate()===(t>dim?dim:t); }
    default: return true;
  }
};

export const getSmartDefaultView = () => {
  const stored = localStorage.getItem('famflow-view');
  if(stored && stored !== 'weekdays') return stored;
  const dow = new Date().getDay();
  if(dow === 0 || dow === 6) return 'week';
  return stored || 'today';
};

const playAudio = (src, muted, vol=0.75) => {
  if(muted) return;
  try { const a=new Audio(src); a.volume=vol; a.play().catch(()=>{}); } catch {}
};
const synthChaChing = (muted) => {
  if(muted) return;
  try{const c=new(window.AudioContext||window.webkitAudioContext)();[[800,0,0.05],[1200,0.06,0.08],[600,0.14,0.12]].forEach(([f,t,dur])=>{const o=c.createOscillator();const g=c.createGain();o.frequency.setValueAtTime(f,c.currentTime+t);g.gain.setValueAtTime(0.3,c.currentTime+t);g.gain.exponentialRampToValueAtTime(0.001,c.currentTime+t+dur);o.connect(g).connect(c.destination);o.start(c.currentTime+t);o.stop(c.currentTime+t+dur);});}catch{}
};
export const makeSounds = (muted) => ({
  success_low:()=>playAudio('/sounds/success_low.wav',muted),
  success:()=>playAudio('/sounds/success.wav',muted),
  mission_success:()=>playAudio('/sounds/mission_success.wav',muted),
  success_jingle:()=>playAudio('/sounds/success_jingle.wav',muted),
  extra_life:()=>playAudio('/sounds/extra_life.wav',muted),
  congrats:()=>playAudio('/sounds/mission_success.wav',muted,0.9),
  uncheck:()=>playAudio('/sounds/oops.wav',muted,0.6),
  chaChing:()=>synthChaChing(muted),
  redeem:()=>playAudio('/sounds/treasure_chest.wav',muted,0.8),
  deny:()=>playAudio('/sounds/fart.wav',muted,0.5),
});

export const injectFavicon = () => {
  const existing = document.querySelector("link[rel~='icon']");
  if(existing) return;
  const canvas = document.createElement('canvas');
  canvas.width = 64; canvas.height = 64;
  const ctx = canvas.getContext('2d');
  ctx.font = '52px serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.fillText('🏠', 32, 36);
  const link = document.createElement('link');
  link.rel = 'icon'; link.type = 'image/png'; link.href = canvas.toDataURL();
  document.head.appendChild(link);
};

// Birthday helpers (pure, no state — usable outside React components)
export const getBirthdayCountdown_static = (member) => {
  if(!member.birthdayMonth||!member.birthdayDay) return null;
  const now=new Date();
  const today=todayISO();
  const mk=(y)=>`${y}-${String(member.birthdayMonth).padStart(2,'0')}-${String(member.birthdayDay).padStart(2,'0')}`;
  let bdISO=mk(now.getFullYear());
  if(bdISO<today) bdISO=mk(now.getFullYear()+1);
  if(bdISO===today) return 0;
  return Math.ceil((new Date(bdISO+'T00:00:00')-new Date(today+'T00:00:00'))/(1000*60*60*24));
};

export const matchesRecurringEvent = (event, dateISO) => {
  if(event.date===dateISO) return true;
  if(event.endDate&&dateISO>=event.date&&dateISO<=event.endDate) return true;
  if(!event.recurrence||event.recurrence==='none') return false;
  if(dateISO<=event.date) return false;
  const [,em,ed] = event.date.split('-');
  const [,dm,dd] = dateISO.split('-');
  if(event.recurrence==='yearly')  return em===dm&&ed===dd;
  if(event.recurrence==='monthly') return ed===dd;
  if(event.recurrence==='weekly'){
    const base=new Date(event.date+'T12:00:00');
    const cur=new Date(dateISO+'T12:00:00');
    return base.getDay()===cur.getDay()&&(cur-base)%(7*86400000)===0;
  }
  if(event.recurrence==='daily') return true;
  return false;
};